// extracted by mini-css-extract-plugin
export default {"logo":"LogoImage2_logo__Emx3-"};